
<progress
  :max="max"
  :value="value"
  class="progress-bar"
  :aria-valuemax="max"
  :aria-valuenow="value"
  :aria-label="ariaLabel"
  :aria-valuetext="content"
  :style="progressBarStyle"
/>
